import React from "react";
import { IoEyeOutline } from "react-icons/io5";
import NavBar from "../../components/common/NavBar";
import Spinner from "../../components/common/Spinner";
import { useStaffOrganisations } from "../../hooks/useReadOnly";
import { getSupportView, startSupportView } from "../../services/supportView";

const EyeIcon = IoEyeOutline as any;

// Telcofy support (#557): pick a customer organisation to open read-only, to
// check their app works and see their data as they do. Staff only; the backend
// logs who opened which organisation.
const SupportPage: React.FC = () => {
  const { isStaff, organisations, loaded } = useStaffOrganisations();
  const current = getSupportView();

  return (
    <div className="min-h-screen">
      <NavBar title="Customer support view" showBackButton />
      <div className="mx-auto max-w-3xl px-4 py-8">
        {!loaded ? (
          <div className="py-16">
            <Spinner />
          </div>
        ) : !isStaff ? (
          <p className="rounded-2xl border border-paper-300/70 bg-surface p-6 text-sm text-ink-muted shadow-soft">
            This page is for Telcofy staff.
          </p>
        ) : (
          <section className="rounded-2xl border border-paper-300/70 bg-surface p-6 shadow-soft">
            <h1 className="font-display text-xl font-bold text-ink">View a customer</h1>
            <p className="mt-1 text-sm text-ink-muted">
              Opens the organisation as one of its viewers: you see its areas, projects, dashboards and team, and nothing can be
              changed. Each view is logged.
            </p>
            <ul className="mt-5 divide-y divide-paper-200">
              {organisations.map((o) => (
                <li key={o.id} className="flex items-center justify-between gap-3 py-3">
                  <div>
                    <p className="text-sm font-medium text-ink">{o.name ?? o.id}</p>
                    <p className="text-xs text-ink-faint">
                      {o.usersInUse} of {o.usersIncluded} users
                      {!o.viewable && " · not moved to organisations yet"}
                    </p>
                  </div>
                  <button
                    onClick={() => startSupportView({ id: o.id, name: o.name ?? o.id })}
                    disabled={!o.viewable || current?.id === o.id}
                    className="inline-flex items-center gap-1.5 rounded-lg border border-paper-300 px-3 py-1.5 text-sm font-medium text-ink transition-colors hover:bg-paper-100 disabled:opacity-40"
                  >
                    <EyeIcon className="h-4 w-4" />
                    {current?.id === o.id ? "Viewing" : "View"}
                  </button>
                </li>
              ))}
              {!organisations.length && <li className="py-3 text-sm text-ink-muted">No organisations yet.</li>}
            </ul>
          </section>
        )}
      </div>
    </div>
  );
};

export default SupportPage;
